import { useNavigate } from 'react-router-dom'

import { Box, Link } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import TextField from 'modules/core/components/TextField'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import EmptyState from 'modules/approvals/components/ApprovalsInformationBlock/EmptyState'
import LeaveOverlaps from 'modules/timeoff/components/LeaveInfo/LeaveOverlaps'

import Documents from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals/components/Documents'
import type { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/TimeoffApprovals/types'

export interface Overlaps {
  in_team: number[]
  overlaps: number[]
}

interface Props {
  collapseContentData: CollapseContentData
}

const RightBlock = ({ collapseContentData }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (collapseContentData.noPermission)
    return (
      <EmptyState
        hideBorder
        title={i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_permission.title'
        )}
        description={i18n.t(
          'settings.approvals.approval_request_view.approval_history.no_permission.description'
        )}
      />
    )

  return (
    <Box width="full" gap="s24">
      {!!collapseContentData.leaveType && (
        <Box>
          <TextField
            readonly
            label={i18n.t('dashboard.todo.approvals.timeoff.leave_type')}
            value={String(collapseContentData.leaveType)}
          />
        </Box>
      )}

      <Box flexDirection="row" gap="s24">
        {!!collapseContentData.startOn && (
          <Box>
            <TextField
              readonly
              label={i18n.t('common.from')}
              value={String(collapseContentData.startOn)}
            />
          </Box>
        )}

        {!!collapseContentData.finishOn && (
          <Box>
            <TextField
              readonly
              label={i18n.t('common.until')}
              value={String(collapseContentData.finishOn)}
            />
          </Box>
        )}
      </Box>

      <Box flexDirection="row" gap="s24">
        {!!collapseContentData.startTime && (
          <Box>
            <TextField
              readonly
              label={i18n.t('common.from')}
              value={String(collapseContentData.startTime)}
            />
          </Box>
        )}

        {!!collapseContentData.duration && (
          <Box>
            <TextField
              readonly
              label={i18n.t('dashboard.todo.approvals.timeoff.duration')}
              value={String(collapseContentData.duration)}
            />
          </Box>
        )}

        {!!collapseContentData.availableUnits && (
          <Box>
            <TextField
              readonly
              label={i18n.t('dashboard.todo.approvals.timeoff.available_label')}
              value={
                collapseContentData.allowanceType == 'days'
                  ? i18n.t('dashboard.todo.approvals.timeoff.available_value_days', {
                      units: String(collapseContentData.availableUnits),
                    })
                  : i18n.t('dashboard.todo.approvals.timeoff.available_value_hours', {
                      units: String(collapseContentData.availableUnits),
                    })
              }
            />
          </Box>
        )}
      </Box>
      {!isEmpty(collapseContentData.documents) && (
        <Documents documents={collapseContentData.documents} />
      )}

      {collapseContentData.overlaps && !!collapseContentData.overlaps.company.total && (
        <Box
          paddingX="s24"
          paddingY="s16"
          textAlign="center"
          background="grey400"
          borderRadius={{
            all: 'abs008',
          }}
        >
          <LeaveOverlaps
            employeeId={collapseContentData.flowOwnerEmployeeId}
            company={collapseContentData.overlaps.company}
            inTeam={collapseContentData.overlaps.inTeam}
          />
        </Box>
      )}

      <Box justifyContent="flexEnd" width="full" flexDirection="row" textAlign="right">
        <Link.Touchable
          expand
          onClick={() => {
            navigate(
              navigation.employees.id.timeOff.leavesEditLeaveId.fullPath({
                id: collapseContentData.flowOwnerEmployeeId,
                leave_id: collapseContentData.approvalFlow.resourceId,
              })
            )
          }}
        >
          {i18n.t('dashboard.todo.approvals.timeoff.link_button')}
        </Link.Touchable>
      </Box>
    </Box>
  )
}

export default RightBlock
